export default __webpack_public_path__ + "static/media/member10.58787c92.svg";